import { StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { ConstructionFeasibilityToDo } from "./constructionFeasibilityToDoDialogContent";
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from "@roc/feature-general-tasks";

export type ConstructionFeasibilityToDoDialogProps = {
  open: boolean;
  loanId: any;
  onClose: () => void;
  document: Document;
}

export const ConstructionFeasibilityToDoDialog = observer((props: ConstructionFeasibilityToDoDialogProps) => {
  const { open, loanId, onClose, document } = props;
  const taskId = document?.taskId;

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Construction Feasibility Review Report"
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={
            <ConstructionFeasibilityToDo
              loanId={loanId}
              onClose={onClose}
              document={document}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Construction Feasibility Review Report"
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={
            <ConstructionFeasibilityToDo
              loanId={loanId}
              onClose={onClose}
              document={document}
            />
          }
        />
      )}
    </>
  )
})

export default ConstructionFeasibilityToDoDialog;